import React, { useCallback, useContext, useEffect, useState } from 'react';
import { navigate, PageProps } from 'gatsby';
import { IconButton, makeStyles, useMediaQuery } from '@material-ui/core';
import { ALFRED_ICON } from 'images/GoogleCloud';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { Route } from '@interfaces';
import { LayoutMobileInvestments } from '@components/Investments/Layout';
import { Plans } from '@components/Services/PersonalizedPlans/Plans';
import { TREN_THUMBNAIL, COOLEBRA_THUMBNAIL } from 'images/GCP';
import { ButtonPrimary } from '@components/Reusables';
import { Tren } from '@components/Services/Benefits/12Tren/12Tren';

const RokinBenefits = () => {
  const classes = useStyles();
  const isMobile = useMediaQuery('(max-width: 1270px)');
  const [openPlans, setOpenPlans] = useState(false);
  const [open12Tren, setOpen12Tren] = useState(false);

  return (
    <>
      <section
        className={
          openPlans && isMobile
            ? classes.hidden
            : `${classes.section} ${classes.sectionHeight}`
        }
      >
        <Tren open={open12Tren} setOpen12Tren={setOpen12Tren} />
        <div className={classes.divSection}>
          <div className={classes.benefits}>
            <span></span>
          </div>
        </div>
        <div className={classes.cardsBackground}>
          <div className={classes.cards}>
            {list.map((card) => (
              <section className={classes.card} key={card.id}>
                <img src={card.image} />
                <h3>{card.name}</h3>
                <p>{card.text}</p>
                <ButtonPrimary
                  onClick={() => {
                    if (card.id === 2) {
                      setOpen12Tren(true);
                    } else {
                      navigate(card.link);
                    }
                  }}
                  text={card.buttonText}
                />
              </section>
            ))}
          </div>
        </div>
      </section>{' '}
      {isMobile && !openPlans && (
        <LayoutMobileInvestments activeServices>
          <></>
        </LayoutMobileInvestments>
      )}
    </>
  );
};

export default RokinBenefits;

const useStyles = makeStyles((theme) => ({
  divSection: {
    [theme.breakpoints.down(1200)]: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'start!important',
      alignItems: 'start!important',
      margin: '0 auto',
      width: '100%',
    },
  },
  layoutOnBoarding: {
    background: (openPlans) =>
      openPlans
        ? '#084554'
        : 'linear-gradient(151deg, rgb(10, 86, 105) 6%, rgb(0, 169, 194) 85%)',

    minHeight: '100vh',
    fontFamily: 'Montserrat',
    '& div': {
      [theme.breakpoints.down(1200)]: {
        marginTop: '0px',
      },
    },
  },
  section: {
    minHeight: '90vh',
    width: '70rem',
    margin: '2rem auto 0',
    [theme.breakpoints.down(1200)]: {
      margin: '3rem auto 0',
      width: '100%',
    },
    '& >div': {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: '2rem',
      [theme.breakpoints.down(1200)]: {
        flexDirection: 'column',
      },
    },
  },
  sectionHeight: {
    [theme.breakpoints.down(1200)]: {
      minHeight: '73vh',
      '& >div': {
        justifyContent: 'start',
      },
    },
  },
  benefits: {
    display: 'flex',
    fontSize: '2.25rem',
    gap: '2rem',
    [theme.breakpoints.down(1200)]: {
      justifyContent: 'space-between',
      width: '90%',
      margin: '0 auto 1rem',
      fontSize: '1.25rem',
      fontWeight: 500,
    },
    '& span': {
      color: 'white',
    },
  },
  alfred: {
    display: 'flex',
    gap: '2rem',
    borderRadius: 20,
    border: `1px solid rgba(244,244,244,0.4)`,
    padding: '1rem 1.3rem',
    cursor: 'pointer',
    [theme.breakpoints.down(1200)]: {
      border: `none`,
      borderTop: `1px solid rgba(244,244,244,0.4)`,
      borderBottom: `1px solid rgba(244,244,244,0.4)`,
      borderRadius: 0,
      padding: '1rem 0.5rem',
      width: '90%',
      margin: '0 auto',
      gap: '1rem',
      justifyContent: 'space-between',
    },
    '& .image': {
      width: '3.5rem',
      height: '3.5rem',
    },
    '& .containerAlfred': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'baseline',
      [theme.breakpoints.down(1200)]: {
        width: '70%',
      },
    },
    '& .alfred': {
      color: 'white',
      [theme.breakpoints.down(1200)]: {
        fontSize: '1rem',
      },
      '& span': {
        color: '#00a9c2',
      },
    },
    '& .solicitude': {
      color: 'white',
      fontSize: '1.5rem',
      fontWeight: 500,
      [theme.breakpoints.down(1200)]: {
        fontSize: '1rem',
      },
    },
    '& .arrow': {
      width: '2rem',
      height: '3rem',
      color: 'white',
    },
  },
  icon: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    cursor: 'pointer',
    paddingBottom: '1.5rem',
    marginBottom: '1.5rem',
    borderBottom: `1px solid #d6d6d6`,
    [theme.breakpoints.down(1200)]: {
      paddingBottom: '0.5rem',
      marginBottom: '0.5rem',
    },
    '& img': {
      width: '2rem',
    },
    '& article': {
      display: 'flex',
      gap: '1.2rem',
      width: '20rem',
      alignItems: 'center',
      '& img': {
        width: '1.5rem',
      },
    },
  },
  pointer: {
    cursor: 'pointer',
  },
  title: {
    marginTop: '0.2rem',
  },
  hidden: {
    display: 'none',
  },
  cardsBackground: {
    background: '#F4F3F3',
    borderRadius: 30,
    height: '25rem',
    [theme.breakpoints.down(1200)]: {
      borderRadius: 20,
      minHeight: '73vh',
    },
  },
  cards: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline!important',
    justifyContent: 'space-between',
    gap: '2rem',
    marginTop: '-3rem',
    marginLeft: '-3rem',
    [theme.breakpoints.down(1200)]: {
      flexDirection: 'column',
      gap: '1rem',
      marginLeft: '0',
      marginTop: '-1rem',
    },
  },

  card: {
    display: 'grid',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '1rem',
    width: '100%',
    height: '100%',
    padding: '2rem',
    borderRadius: 20,
    background: 'white',
    boxShadow: '5.3px 5.3px 10.5px 2.6px rgba(0, 0, 0, 0.25)',
    '& img': {
      width: '24rem',
    },
    '& h3': {
      fontSize: '1rem',
      fontWeight: 'bold',
      color: '#393e44',
      fontFamily: 'Montserrat',
    },
    '& p': {
      fontSize: '0.75rem',
      color: '#646464',
      fontFamily: 'Nunito',
    },
    '& button': {
      width: '100%',
      height: '3rem',
      cursor: 'pointer',
    },
  },
}));

const list = [
  {
    id: 1,
    name: 'Coolebra',
    text: 'Encuntra los descuentos de tus tarjetas',
    buttonText: 'Quiero ver mis descuentos',
    image: COOLEBRA_THUMBNAIL,
    link: 'https://coolebra.com/',
  },
  {
    id: 2,
    name: '12Tren',
    text: 'Compra directo de las fábricas y ahorra un 44% respecto a los supermercados',
    buttonText: 'Quiero ahorrar en mis compras',
    image: TREN_THUMBNAIL,
    link: 'https://12tren.com/login/',
  },
];
